import React from 'react';
import { gallery } from '../data/gallery';
export function Gallery() {
  return <section id="work" className="w-full bg-white py-16 lg:py-24" data-id="element-20" data-mp="34cqa1722l1t3">
      <div className="mx-auto w-full max-w-7xl px-5 lg:px-10" data-id="element-21" data-mp="34ej7bvqsm9of">
        <h2 className="font-heading text-4xl font-black uppercase leading-none tracking-tight text-[#0B1B3A] lg:text-5xl" data-id="element-22" data-mp="3ib6h4z3ugubr">
          Recent work
        </h2>
        <p className="mt-4 max-w-xl text-[#0B1B3A]/70" data-id="element-23" data-mp="2pnk2mvt2w5a4">
          Clean lines, even coverage, and a jobsite left tidier than we found
          it.
        </p>

        <ul className="mt-10 grid gap-6 md:grid-cols-3" data-id="element-24" data-mp="2kq23fx4v54fb">
          {gallery.map(item => <li key={item.src} className="group" data-id="element-25" data-mp="2zey77hzvzva4">
              <div className="overflow-hidden border-4 border-[#0B1B3A]" data-id="element-26" data-mp="2umx00ahksuqy">
                <img src={item.src} alt={item.alt} className="aspect-[4/3] w-full object-cover transition-transform duration-300 group-hover:scale-105" loading="lazy" data-id="element-27" data-mp="2ukkbfehbbm4x" />
              </div>
              <p className="mt-3 font-heading text-sm font-black uppercase tracking-widest text-[#0B1B3A]" data-id="element-28" data-mp="rc1h8k0emkag">
                {item.label}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}